export const SET_RECURRING_TASKS = "SET_RECURRING_TASKS";
export const REMOVE_RECURRING_TASK = "REMOVE_RECURRING_TASK";
export const UPDATE_TASK_FREQUENCY = "UPDATE_TASK_FREQUENCY";
